import * as React from "react"
import { cn } from "@/lib/utils"
import { useIsMobile } from "@/hooks/use-mobile"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    const isMobile = useIsMobile();
    const isFile = type === "file";
    
    return (
      <input
        type={type}
        className={cn(
          "flex w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-foreground file:font-sans placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 transition-all duration-200",
          // Mobile-optimized sizing with proper typography
          isMobile 
            ? cn(
                "h-12 text-base px-4 py-3 touch-manipulation",
                isFile ? "file:text-sm file:font-normal file:mr-3 file:px-3 file:py-2 file:leading-normal" : "file:text-base file:font-medium file:mr-4 file:leading-normal"
              )
            : cn(
                "h-10 md:text-sm",
                isFile ? "file:text-sm file:font-normal file:leading-normal" : "file:text-sm file:font-medium file:leading-normal"
              ),
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
